import { render, staticRenderFns } from "./ImageHorizontal.vue?vue&type=template&id=71b5b7a0&scoped=true&lang=pug&"
import script from "./ImageHorizontal.vue?vue&type=script&lang=ts&"
export * from "./ImageHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./ImageHorizontal.vue?vue&type=style&index=0&id=71b5b7a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5b7a0",
  null
  
)

export default component.exports